<div class="pt-4 pb-6 px-6 rounded-3xl" id="marketing__container">
  <img
    src="/assets/icons/arrow.svg"
    alt="Arrow"
    class="inset-0 h-16 w-16 m-auto"
  />
  <div class="flex flex-col justify-center items-center p-2">
    <p class="font-sans p-2 text-xl font-medium" id="marketing__title">
      {{ "marketing.title" | transloco }}
    </p>
    <p class="font-sans text-center">{{ "marketing.message" | transloco }}</p>

    <div class="flex flex-col pt-6">
      <button
        class="!text-white !bg-blue-30 !px-6 py-3 !rounded-[0.75rem] !font-bold"
        ed-button
        edType="primary"
        (click)="confirm()"
        [loading]="false"
        id="marketing__confirm-button"
      >
        {{ "marketing.keep_me_updated" | transloco }}
      </button>

      <button
        class="!rounded-[0.75rem] mt-2 !font-bold !px-6 py-3"
        ed-button
        edType="secondary"
        (click)="deny()"
        [loading]="false"
        id="marketing__deny-button"
      >
        {{ "marketing.updates_rejection" | transloco }}
      </button>
    </div>
  </div>
</div>
